/* jshint undef: true, unused: true */

var me = require('../me');
var GQLURI = graphQlEnvUri(window.location);
var instance = new GraphQLWrapperInstance();

function checkLocale(locale) {
  if (typeof locale !== 'string') {
    return false;
  }
  const match = locale.match(/^[a-z]{2}_[A-Z]{2}$/);
  return match && match.length === 1;
}

function getReadableErrors(errors) {
  return 'Errors: ' + errors.map(error => {
    return `${error.message} for ${error.path.join('->')}`;
  }).join(', ');
}

function ajaxCall(query) {
  return new Promise(function(success, fail) {
    me.getISOLocale()
      .then(function(locale) {
        if (!checkLocale(locale)) {
          throw `Graphql Wrapper: Attempted to pass invalid locale "${locale}" into graphql query. Contact administrator.`;
        }

        query = query.replace('$locale', locale);

        var data = JSON.stringify({
          query: query,
        });

        fail = fail || function(err) { throw err; };

        $.ajax({
          url: GQLURI,
          type: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
          },
          data: data
        })
          .done(function (response) {
            if (response.errors && response.errors.constructor === [].constructor) {
              fail(getReadableErrors(response.errors));
            } else {
              if (response.data) {
                success(response);
              } else {
                fail(response);
              }
            }
          })
          .fail(fail);
      })
      .catch(fail);
  });
}

function GraphQLWrapperInstance() {
  this.ajaxCall = ajaxCall;
  this.getReadableErrors = getReadableErrors;
}

// Instantiating as a factory/singleton so that the AJAX call can easily be setup with starting variables if necessary.
function getInstance() {
  return instance;
}

module.exports = getInstance;

function graphQlEnvUri(windowLocation) {
  return windowLocation.protocol + '//' + windowLocation.host + '/iris/q';
}
